/**
 * Dinero: `Decimal` en la base de datos, `number` con 2 decimales en el borde de la API
 * (CLAUDE.md regla 4). Estas funciones son el único lugar donde se redondea.
 */
/** Redondeo comercial a 2 decimales (half-up), a prueba del error binario de IEEE-754. */
export function redondear2(valor) {
    if (!Number.isFinite(valor))
        throw new RangeError(`Valor no finito: ${valor}`);
    const escalado = valor * 100;
    // 1e-9 corrige casos como 1.005 * 100 = 100.49999999999999
    const redondeado = Math.round(escalado + (escalado >= 0 ? 1e-9 : -1e-9));
    return redondeado / 100;
}
/** Convierte lo que devuelve Prisma para un `Decimal` al `number` del borde de la API. */
export function decimalANumero(valor) {
    if (valor === null || valor === undefined)
        return null;
    const n = typeof valor === 'number' ? valor : Number(valor.toString());
    return Number.isFinite(n) ? redondear2(n) : null;
}
/** Igual que `decimalANumero` pero para campos obligatorios. */
export function decimalANumeroReq(valor) {
    const n = decimalANumero(valor);
    if (n === null)
        throw new TypeError('Decimal obligatorio ausente');
    return n;
}
//# sourceMappingURL=dinero.js.map